module.exports = __webpack_public_path__ + "static/media/icon_arrow_up.7b1d0039.webp";